import { SessionStorage } from '@bhtp-client-api/base';
import { Constants } from '@bhtp-client-web/component';
import { EditContainerData } from './view-models/edit-container-data';
import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class EditSessionStorage {
    readonly expireTimeMinutes: number = 30;
    readonly sessionKey: string = 'editSession';
    readonly format: string = Constants.DATE_PARSE_FORMAT + ' HH:mm:ss';

    constructor(private sessionStorage: SessionStorage) {
    }

    public setSession(data: EditContainerData): void {
        let wrappedData: StorageWrap<EditContainerData> = new StorageWrap<EditContainerData>();
        wrappedData.data = data;
        wrappedData.dateTimeStored = moment().format(this.format);

        this.sessionStorage.storeValueOfType<StorageWrap<EditContainerData>>(this.sessionKey, wrappedData);
    }

    public getSession(): EditContainerData {
        let retrievedValue: StorageWrap<EditContainerData> = this.sessionStorage.getValueOfType<StorageWrap<EditContainerData>>(this.sessionKey);
        let returnValue: EditContainerData = null;

        if (retrievedValue && retrievedValue.dateTimeStored) {
            let expireDateTime: moment.Moment = moment(retrievedValue.dateTimeStored, this.format).add(this.expireTimeMinutes, 'minutes');
            let currentDateTime: moment.Moment = moment();

            if (true || currentDateTime < expireDateTime) {
                return retrievedValue.data;
            }
        }

        return returnValue;
    }

    public clearSessionData(): void {
        this.sessionStorage.removeValue(this.sessionKey);
    }
}

export class StorageWrap<T> {
    public data: T;
    public dateTimeStored: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/edit-session-storage.ts